module.exports = __webpack_public_path__ + "img/TV_clean_box00.2ecfdb02.jpg";